import { AxiosRequestConfig } from 'axios';
import { useMutation } from 'react-query';
import { isAtmSearchFormEmpty } from 'src/components/Common/UI/SydFilter/SydFilterTypeChecker';
import { filterNonEmptyValues } from 'src/helpers/AppCode';
import { axiosDefaultApi } from 'src/lib/axios'
import { MutationConfig} from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';

const header: AxiosRequestConfig = {responseType: "arraybuffer"}

const mapFilterData = (data: IAtmSearchForm): IAtmSearchPost | {} => {
  const newData: IAtmSearchForm = {...data};
  if (isAtmSearchFormEmpty(data) || data == undefined) { return {} };
  
  const removedUnusedFilters = filterNonEmptyValues(newData);
  return removedUnusedFilters;
}

const getAtmDownloadExcel = ( {data} : {data: IAtmSearchForm}): Promise<string> => {
  const filterData = mapFilterData(data);
  const deleted = data.deleted ? data.deleted : false;

  return axiosDefaultApi.post(`api/Search/ExportToExcel/Atm?pageNumber=1&pageSize=5000&deleted=${deleted}`, filterData, header);
};

type QueryFnType = typeof getAtmDownloadExcel;

type UseGetAtmDownloadExcelOptions = {
  data: IAtmSearchForm;
  config?: MutationConfig<QueryFnType>;
};

export const useGetAtmDownloadExcel = ({ config }: UseGetAtmDownloadExcelOptions) => {
  const {addNotification, setIsNotificationVisible} = useNotification();

  return useMutation({
    onError: (error: any) => {
      addNotification(`Υπήρξε κάποιο πρόβλημα στο κατέβασμα του αρχείου Excel των τηλεφωνικών γραμμών.`, 500);
      setIsNotificationVisible(true);
      console.error('An error occurred while downloading Phone Line excel:', error);
    },
    onSuccess: () => {
      console.log('Phone Line report excel downloaded successfully.');
    },
    ...config,
    mutationFn: getAtmDownloadExcel,
  })
}